<section id="anandimaa-section">
    <div class="section-bg bg-color-secondary-lighter"></div>
    <div class="container inner-section">
        <div class="row">
            <div class="col-lg-6 inner-details mb-5 mb-lg-0" >
                <div class="details-container">
                    <p class="color-light">CareNX</p>
                    <h1 class="mb-3 color-secondary">Anandi</h1>
                    <p class="mb-3 color-primary my-4">
                        An Al-enabled, high-risk pregnancy
                        management service that aims to ensure
                        healthier pregnancies majorily across the
                        remote regions of the country with the help
                        of healthcare providers.
                    </p>
                    <div class="intro-buttons">
                        <a routerLink="/offering/anandi" color="secondary" button-filled>
                            Know More</a>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 inner-visual" >
                <div>
                    <div class="inner-img">
                        <!--<img alt="NST / CTG Machine in India, Fetal Monitor, smartphone based portable NST/CTG machine, portable NST/CTG machine, Fetosense, CareNX" src="../../../../assets/images/home/products/anandimaa.jpg">-->
                        <video src="../../../../assets/video/anandimaa.mp4" [muted]="'muted'" preload="auto" playsinline loop autoplay></video>
                    </div>
                </div>
            </div>
            
        </div>
    </div>
</section>